module.exports = __webpack_public_path__ + "img/Unitychan6.29103390.png";